import {
   GET_CUSTOMERS,
   CHANGE_VALUE_INPUTS_CUSTOMER,
   SAVE_ITEM_CUSTOMER,
   GET_INFO_CUSTOMER,
   DELETE_ITEM_CUSTOMER,
   CUSTOMER_DEFAULT_DATA
} from '../constants/customers';

export const customers = ( state = {}, action ) => {
   switch ( action.type ) { 

      case GET_CUSTOMERS : {
         return action.payload;
      }

      case CHANGE_VALUE_INPUTS_CUSTOMER : {
         return action.payload;
      }

      case SAVE_ITEM_CUSTOMER : {
         return action.payload;
      }

      case GET_INFO_CUSTOMER : {
         return action.payload;
      }

      case DELETE_ITEM_CUSTOMER : {
         return action.payload;
      }

      case CUSTOMER_DEFAULT_DATA : {
         return action.payload;
      }
 
     default :
     return state;
   }
}